export default {
  name: 'machineInductedMember',
  miniSave: true,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    return requestFunction
      .methodRequest(`/register/machine/induction/${data.machineid}/operator`, 'POST', data)


  },
}